import { render, staticRenderFns } from "./CircularPiano.vue?vue&type=template&id=65c7fdd1&scoped=true"
import script from "./CircularPiano.vue?vue&type=script&lang=ts"
export * from "./CircularPiano.vue?vue&type=script&lang=ts"
import style0 from "./CircularPiano.vue?vue&type=style&index=0&id=65c7fdd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7fdd1",
  null
  
)

export default component.exports